export default __webpack_public_path__ + "static/media/product-placeholder.5f989f77.png";